import { ISSUES_URL } from "./constants.js";
import { logger } from "./logger.js";

export const handleError = (error: unknown): never => {
  logger.break();
  logger.error("Something went wrong. Please check the error below for more details.");
  logger.error(`If the problem persists, please open an issue at ${ISSUES_URL}.`);
  logger.error("");
  if (error instanceof Error) {
    logger.error(error.message);
  } else {
    logger.error(String(error));
  }
  logger.break();
  process.exit(1);
};
